import { Fade } from "@mui/material"
import { useTaskQuery } from "../../generated/graphql"
import { FormatDateTime } from "../FormatDate/FormatDate"
import styles from './OverlapItem.module.scss'

interface OverlapItemProps {
    taskId: string
}

export default function OverlapItem(props: OverlapItemProps) {
    const { taskId } = props
    const { data, loading, error } = useTaskQuery({ variables: { id: taskId } })

    if (error) {
        throw new Error(error.message)
    }

    return (
        <Fade in={!loading}>
            <div className={styles.Wrapper}>
                <p>{data?.task?.name}</p>
                <p><b>Contrato:</b> {data?.task?.intervention?.workPermit?.contract?.name} <small>({data?.task?.intervention?.workPermit?.contract?.description})</small></p>
                <p><b>Via:</b> {data?.task?.road?.name} ({data?.task?.direction.name})</p>
                <p><b>Pks:</b> {data?.task?.startPk} - {data?.task?.endPk}</p>
                <p><b>Início:</b> <FormatDateTime datetime={data?.task?.startAt} /></p>
                <p><b>Fim:</b> <FormatDateTime datetime={data?.task?.endAt} /></p>
                <p><b>Esquema:</b> {data?.task?.layout?.name}</p>
                <p><b>Motivo:</b> {data?.task?.reason}</p>
            </div>
        </Fade>
    )
}
